import { useUser } from '~/features/user/hooks/use-user';
import { useClientRender } from '~/hooks/use-client-render';

import { getBrowserLocaleForResolvedLanguage } from '../utils/get-browser-locale-for-resolved-language';
import { resolveLanguage } from '../utils/resolve-language';

export function useResolvedLanguage(detectedLocale: string): string {
  const isClient = useClientRender();
  const { isUserAuthenticated, userPreferences, userPreferencesIsFetched } = useUser();
  const preferredLanguage = isUserAuthenticated ? userPreferences?.preferredLanguage : undefined;
  const preferredLanguageIsManual = isUserAuthenticated ? userPreferences?.preferredLanguageIsManual : undefined;
  const browserLocale = getBrowserLocaleForResolvedLanguage({
    detectedLocale,
    isClient,
    isUserAuthenticated,
    liveBrowserLocale: isClient ? window.navigator.language : undefined,
    userPreferencesIsFetched,
  });

  return resolveLanguage({
    browserLocale,
    preferredLanguage,
    preferredLanguageIsManual,
  });
}
